/**
 * Pro link utilities - handles Pro upgrade URLs and styles
 *
 * Now uses shared utilities for brand context and URL building.
 *
 * @module lib/proLinks
 */

const { resolveBrandContext } = require('./utils/brandContext');
const { buildMillaAuthUrl } = require('./utils/millaAuth');
const { injectStyles } = require('./utils/styleInjector');

/**
 * Pro link CSS styles
 */
const PRO_LINK_STYLES = `
a.milla-pro-link {
  font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif !important;
  font-size: 12px !important;
  font-weight: 600 !important;
  text-transform: uppercase !important;
  letter-spacing: 0.08em !important;
  color: #6b7280 !important;
  text-decoration: none !important;
  border-bottom: none !important;
  white-space: nowrap !important;
}
a.milla-pro-link:hover {
  color: #111827 !important;
  text-decoration: none !important;
  border-bottom: none !important;
}
.ad-flex > a.milla-pro-link {
  display: block !important;
  width: fit-content !important;
  margin-left: auto !important;
  margin-right: auto !important;
  margin-bottom: 12px !important;
}
`;

/**
 * Resolve the current site/brand context for Pro links
 * @returns {{ brand: string, language: string }}
 */
function resolveProLinkContext() {
  return resolveBrandContext();
}

/**
 * Build the Pro upgrade URL that respects environment and site context
 * @param {string} [source] - Optional source identifier for tracking
 * @returns {string} The Pro upgrade URL pointing to /subscription
 */
function buildProUpgradeUrl(source) {
  const ctx = resolveBrandContext();
  const src = typeof source === 'string' && source.trim() ? source.trim() : 'ad_link';

  return buildMillaAuthUrl('/subscription', {
    brand: ctx.brand,
    source: src
  });
}

/**
 * Inject Pro link styles into the document
 */
function ensureProLinkStyles() {
  injectStyles('milla-pro-link-styles', PRO_LINK_STYLES);
}

module.exports = {
  PRO_LINK_STYLES,
  resolveProLinkContext,
  buildProUpgradeUrl,
  ensureProLinkStyles
};
